<template>
<!-- 
    * Copyright: T-Systems México S.A. de C.V.
    * Descripción: Vista ubicaciones, permite consultar, crear, editar y eliminar ubicaciones de las pantas T-systems
    * Autor: 
    * F.Creación: 
  -->
  <layout :title="$t('moduleTitle')">
    <!-- Contenido -->
    <template v-slot:content>
      <v-text-field
        solo
        class="mt-4"
        :label="$t('lblSearch')"
        prepend-inner-icon="mdi-account"
        v-model="search"
      ></v-text-field>
      <!-- Invocacion de componente settings -->
      <settings
        :settings="currentSettings"
        :locationId="currentLocation.id"
        :location="currentLocation"
        :dialogFlag="editSettingsDialogFlag"
        @closeSettingsDialogEvent="closeSettingsDialog()"
        @reloadLocationsEvent="reLoadData()"
      />
      <!-- Tabla de contenido -->
      <v-data-table
        :headers="headers"
        :items="locations"
        :loading="isLoading"
        :search="search"
        loading-text="Cargando elementos en tabla"
        color="primary"
        v-if="editSettingsDialogFlag === false"
      >
        <template v-slot:top>
          <v-toolbar flat color="primary">
            <v-toolbar-title class="white--text">{{$t('tblTitle')}}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
             <!-- modal con formulario para la creacion y edicion de ubicacion -->
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="ma-2" outlined color="white" v-on="on">{{$t('tblbutton')}}</v-btn>
              </template>
              <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="editedItem.name" :label="$t('mdltext1')"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="editedItem.comments" :label="$t('mdltext2')"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="grey" text @click="close">{{$t('mdlCancel')}}</v-btn>
                  <v-btn color="primary" text @click="save">{{$t('mdlSave')}}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <!-- Panel de estado -->
        <template v-slot:item.estado="{ item }">
          <v-col v-if="item.status === 1">
            <v-btn icon color="primary" @click="deleteItem(item)">
              <v-icon>mdi-thumb-up</v-icon>
            </v-btn>
          </v-col>
          <v-col v-else>
            <v-btn icon color="grey" @click="deleteItem(item)">
              <v-icon>mdi-thumb-down</v-icon>
            </v-btn>
          </v-col>
        </template>
        <!-- Panel de acciones -->
        <template v-slot:item.action="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon class="mr-2" color="grey" v-on="on" @click="editItem(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>{{$t('lblEdit')}}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon class="mr-2" color="grey" v-on="on" @click="navigateRooms(item)">
                <v-icon>mdi-seat-recline-normal</v-icon>
              </v-btn>
            </template>
            <span>{{$t('lblMeeting')}}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon class="mr-2" color="grey" v-on="on" @click="navigateCarsForReservation(item)">
                <v-icon>mdi-car</v-icon>
              </v-btn>
            </template>
            <span>Autos</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon class="mr-2" color="grey" v-on="on" @click="navigateBikesForReservation(item)">
                <v-icon>mdi-bike</v-icon>
              </v-btn>
            </template>
            <span>Bicicletas</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon class="mr-2" color="grey" v-on="on" @click="editSettings(item)">
                <v-icon>mdi-clipboard-text</v-icon>
              </v-btn>
            </template>
            <span>{{$t('lblSetting')}}</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-snackbar v-model="snackbar">
        {{ mensaje }}
        <v-btn color="primary" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </template>
  </layout>
</template>

<script>
// Incluimos el LAYOUT estandar para los usuario que ya tienen
// una sesión activa
import Layout from "@/components/Layouts/company";
// Incluimos los mensajes de esta pantalla
import i18nMessages from "./i18n.messages";
import { mapGetters } from "vuex";
import Settings from "./settings/index";
import _ from "lodash";

const DEFULT_SETTINGS = [];
const DEFULT_LOCATION = { id: 0 };

export default {
   // Se definen los componentes requeridos por esta pantalla
  components: {
    layout: Layout,
    settings: Settings
  },
  created() {
    this.$i18n.locale = this.locale;
     // Obtenemos la lista de ubicaciones
    this.loadData();
    //inicializamos encabezados de la tabla
    this.updateHeadersLocale();
  },
  updated() {
    if (this.search != "") {
      //** console.log("beforeUpdate: cambio de estados");
    }
  },
  beforeDestroy() {},
  i18n: i18nMessages,
  data: function() {
    return {
      currentSettings: DEFULT_SETTINGS,
      editSettingsDialogFlag: false,
      currentLocation: DEFULT_LOCATION,

      snackbar: false,
      mensaje: "",

      search: "",
      loading: true,
      dialog: false,
      locations: [],
      //encabezados de la tabla
      headers: [
        {
          id: "headerUbicacion",
          text: "Localidad",
          sortable: true,
          value: "name"
        },
        { id: "headerDescripcion", text: "Descripcion", value: "comments" },
        {
          id: "headerEstado",
          text: "Estado",
          value: "estado",
          sortable: false
        },
        {
          id: "headerAcciones",
          text: "Acciones",
          value: "action",
          sortable: false
        }
      ],
      editedItem: {
        id: null,
        name: null,
        comments: "",
        status: 1
      }
    };
  },
  mounted: () => {},
  computed: {
    ...mapGetters(["isLoading"]),
    locale() {
      return this.$store.getters["locale"];
    },
    formTitle() {
      return this.editedItem.id == null
        ? this.$t("mdltext3")
        : this.$t("mdltext4");
    }
  },
  watch: {
    locale(value) {
      this.$i18n.locale = value;
      this.updateHeadersLocale();
    }
  },
  methods: {
    // Actualiza el idioma de los encabezados de la tabla
    updateHeadersLocale() {
      this.headers = this.headers.map(header => {
        header.text = this.$t(header.id);
        return header;
      });
    },
    //consulta de ubicaciones desde lambda, asignacion de datos a arreglo locations
    loadData() {
      return this.$GET("/api/locationsDistinct")
        .then(locations => {
          this.locations = locations;
          return this.locations;
        })
        .catch(() => { 
          //** console.log(e)
        });
    },
    reLoadData(){
      this.loadData().then((locations)=> {
        let location = locations.find( location => location.id === this.currentLocation.id )
        this.currentSettings = _.clone(location.configurations)
      })
    },
    editSettings(item) {
      //** console.log("editSettings");
      //** console.log(item);
      this.currentLocation = _.clone(item);
      this.currentSettings = _.clone(item.configurations);
      this.editSettingsDialogFlag = true;
    },
    //
    closeSettingsDialog() {
      this.currentLocation = DEFULT_LOCATION;
      this.currentSettings = DEFULT_SETTINGS;
      this.editSettingsDialogFlag = false;
    },

    navigateRooms(item) {
      this.$router.push({ path: "rooms/" + item.id });
    },
    navigateCarsForReservation(item) {
      this.$router.push({ path: "/carsForReservation/" + item.id });
    },
    navigateBikesForReservation(item) {
      this.$router.push({ path: "/BikesForReservation/" + item.id });
    },
    editItem(item) {
      //this.editedIndex = this.locations.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      //** console.log(item.id);
      let body = {
        params: {
          id: item.id
        },
        data: {
          name: item.name,
          lastUpdate: item.lastUpdate,
          comments: item.comments,
          status: item.status === 0 ? 1 : 0
        }
      };
      //** console.log("/api/locations/", body);
      this.$PUT("/api/locations/{{id}}", body)
        .then(() => {
          // //** console.log(this.locations),
          // Object.assign(this.locations[this.editedIndex], this.item)
          this.loadData();
        })
        .catch(() => { 
          //** console.log(e)
        });
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, {
        id: null,
        name: null,
        comments: "",
        status: 1
      });
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      if (this.editedItem.name == null) {
        this.mensaje =
          "Corrige errores de validacion, debes llenar el campo ubicacion";
        this.snackbar = true;
      } else {
        if (this.editedItem.id != null) {
          let body = {
            params: {
              id: this.editedItem.id
            },
            data: {
              name: this.editedItem.name,
              lastUpdate: this.editedItem.lastUpdate,
              comments: this.editedItem.comments,
              status: this.editedItem.status
            }
          };
          //** console.log("/api/locations/", body);
          this.$PUT("/api/locations/{{id}}", body)
            .then(() => {
              this.close();
              //Object.assign(this.locations[this.editedIndex], this.editedItem);
              this.loadData();
              
            })
            .catch(() => { 
          //** console.log(e)
        });
        } else {
          if (this.editedItem.name == null) {
            this.mensaje =
              "Corrige errores de validacion, debes llenar el campo ubicacion";
            this.snackbar = true;
          } else {
            this.editedItem.id = null;
            this.editedItem.status = 1;
            let content = {
              data: this.editedItem
            };
            //** console.log("/api/locations", content);
            this.$POST("/api/locations", content)
              .then(data => {
                //** console.log(data);
                let settings = {
                  params: {
                    locationId: data.id
                  },
                  data: {
                    minutes: 0,
                    name: "Sala de Juntas",
                    itemTypeId: 1,
                    checkInAfter: 0,
                    checkInBefore: 0,
                    maxRecurrency: 0
                  }
                };
                //** console.log("/api/locations/{{locationId}}/settings", settings);
                this.$POST("/api/locations/{{locationId}}/settings", settings)
                  .then(() => {
                    // //** console.log(settingsResponse);
                    // this.locations.push(this.editedItem);
                    this.close();
                    this.loadData();
                  })
                  .catch(() => { 
          //** console.log(e)
        });
              })
              .catch(() => { 
          //** console.log(e)
        });
          }
        }
      }
      
    }
  }
};
</script>